import { ContentObserver } from '@angular/cdk/observers';
import { Component, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ComboHolder } from 'src/app/holders/combo-holder';
import { Combo, ComboItemGroupModel } from 'src/app/models/combo';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { ItemMenuService } from 'src/app/services/item-menu.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { WorkWeekService } from 'src/app/services/work-week.service';
import { ActionDialogComponent } from '../dialogs/action-dialog/action-dialog.component';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';
import { InputDialogComponent } from '../dialogs/input-dialog/input-dialog.component';
import { OrderTypePickerDialogComponent } from '../dialogs/order-type-picker-dialog/order-type-picker-dialog.component';
import { SummaryDialogComponent } from '../dialogs/summary-dialog/summary-dialog.component';

@Component({
  selector: 'app-combo',
  templateUrl: './combo.component.html',
  styleUrls: ['./combo.component.scss']
})
export class ComboComponent implements OnInit 
{
  @ViewChild('bottomBar', { read: MatRipple })
  ripple?: MatRipple;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  comboHolder:ComboHolder = new ComboHolder();
  currentPriceString:string = '';
  canSave:boolean = false;
  canPop:boolean = false;
  canGoToItem:boolean = false;
  rippleColor:string = "#FFFFFF25";

  status:string = 'new';

  isRedirect:boolean = false;
  comboLink:string = '';
  isClosed:boolean = false;
  isError:boolean = false;

  constructor(
    private itemmenuservice:ItemMenuService, 
    private initializationservice:InitializationService, 
    private route: ActivatedRoute, 
    private currentorderservice:CurrentOrderService,
    private navigationservice:NavigationService,
    public alertDialog: MatDialog,
    private router:Router,
    private ngzone: NgZone,
    private localeservice:LocaleService,
    private _snackBar: MatSnackBar,
    private workweekservice: WorkWeekService,
    private currentinfoservice: CurrentInfoService,
    private pixelservice:AnalyticsService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.isClosed = !(this.workweekservice.isOpen() && this.currentinfoservice.isOpen());

    var combouid = String(this.route.snapshot.paramMap.get('combouid'))

    this.comboLink = `${window.location.origin}/${appname}/direct/combo/${combouid}`;

    this.isRedirect = String(this.route.snapshot.queryParamMap.get('isredirect')) === 'true';

    this.status = String(this.route.snapshot.queryParamMap.get('status'));

    if(this.status === 'new')
    {
      if(this.currentorderservice.checkCurrentNewCombo(combouid) === false)
      {
        this.comboHolder = this.itemmenuservice.getComboHolder(combouid);

        this.checkForSingleItems();

        this.checkGroupDescriptions();

        this.currentorderservice.setCurrentCombo(this.comboHolder);
      }
      else
      {
        this.comboHolder = this.currentorderservice.getCurrentCombo();
        
        this.checkGroupDescriptions();
      }
    }

    if(this.status === 'edit')
    {
      if(this.currentorderservice.checkCurrentEditCombo(combouid) === false)
      {
        this.comboHolder = this.currentorderservice.getCombo(combouid);

        this.currentorderservice.setCurrentCombo(this.comboHolder);
      }
      else
      {
        this.comboHolder = this.currentorderservice.getCurrentCombo();
        
        this.checkGroupDescriptions();
      }
    }

    if(this.comboHolder.Combo.UniversalID.length === 0)
    {
      this.isError = true;

      return;
    }

    this.updateCurrentPrice();

    setTimeout(() => this.updateCanSave(), 300);
  }

  countTap(amount:number)
  {
    if(amount === 0)
    {
      let dialogRef = this.alertDialog.open(InputDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Detail"),
          accept:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Accept"),
          cancel:this.localeservice.instantTranslation("Dialogs.Stepper.ItemCount.Cancel"), 
          content: String(this.comboHolder.Combo.ComboCount) 
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        if(result !== null && result != undefined && result !== '')
        {
          var newCount = Number(result);

          if(newCount !== null && newCount !== undefined)
          {
            if(newCount < 1)
              newCount = 1;

            this.comboHolder.Combo.ComboCount = newCount;

            this.updateCurrentPrice();
          }
        }
      });

      return;
    }

    this.comboHolder.Combo.ComboCount += amount;

    if(this.comboHolder.Combo.ComboCount < 1)
      this.comboHolder.Combo.ComboCount = 1;

    this.updateCurrentPrice();
  }

  back()
  {
    this.navigationservice.back();
  }

  goHome()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));
      
    this.router.navigateByUrl('/' + appname);
  }

  canReturn()
  { 
    if(this.isError)
      return true;

    if(this.canGoToItem === true)
      return true;

    if(this.canPop === true)
    {
      this.currentorderservice.clearCurrentCombo();

      return true;
    }

    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
      return true;
    
    return new Promise<boolean>((resolve, reject) =>
    {
      let dialogRef = this.alertDialog.open(AlertDialogComponent, {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Title"), 
          detail:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Detail"), 
          accept:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Accept"), 
          cancel:this.localeservice.instantTranslation("Dialogs.Alert.ReturnWarning.Cancel")  
        }
      });

      dialogRef.afterClosed().subscribe(result => 
      {
        if(result === true)
        {
          this.currentorderservice.clearCurrentCombo();

          if(this.isRedirect)
          {
            this.canPop = true;
    
            this.goHome()
    
            resolve(false);
          }
          else
            resolve(true);
        }
        else
          resolve(false);
      });
    });
  }

  updateCurrentPrice()
  {
    this.currentPriceString = this.localeservice.getCurrencyString(this.comboHolder.CurrentPrice);
  }

  checkForSingleItems()
  {
    for (let index = 0; index < this.comboHolder.Combo.ItemGroupsList.length; index++) 
    {
      const itemGroup = this.comboHolder.Combo.ItemGroupsList[index];

      for (let index = 0; index < itemGroup.ItemPresetList.length; index++) 
      {
        const itemPreset = itemGroup.ItemPresetList[index];
        
        var item = this.itemmenuservice.getMenuItem(itemPreset.ItemUniversalID);

        if(item !== null && item !== undefined && item.ID.length > 0 && this.itemmenuservice.isItemOutOfStock(item))
        {
          itemGroup.ItemPresetList.splice(index, 1);

          index--;
        }
      }

      if (!itemGroup.AllowEmpty && itemGroup.ItemPresetList.length == 1 && itemGroup.CurrentItem.length === 0)
      {
        var itemHolder = this.itemmenuservice.getMenuItemHolder(itemGroup.ItemPresetList[0].ItemUniversalID);

        itemHolder.MenuItem.ItemCount = itemGroup.ItemPresetList[0].Count;

        itemGroup.IsOptionalOkay = itemHolder.getValidation();

        itemGroup.CurrentItem = itemHolder.MenuItem.ID;
        itemGroup.ItemName = itemHolder.CountName;

        if (itemGroup.IsOptionalOkay === false)
            itemGroup.ItemSummary = itemHolder.GetFirstOptionalMessage();
        else
            itemGroup.ItemSummary = itemHolder.Summary;

        this.comboHolder.ComboItemHolders.push(itemHolder);
      }
    }
  }

  checkGroupDescriptions()
  {
    for (let index = 0; index < this.comboHolder.Combo.ItemGroupsList.length; index++) 
    {
      const itemGroup = this.comboHolder.Combo.ItemGroupsList[index];

      if (itemGroup.CurrentItem.length > 0)
      {
        var itemHolder = this.comboHolder.ComboItemHolders.find(holder => holder.MenuItem.ID === itemGroup.CurrentItem);

        if(itemHolder !== undefined)
        {
          itemGroup.IsOptionalOkay = itemHolder.getValidation();

          if (itemGroup.IsOptionalOkay === false)
          {
            itemGroup.ItemSummary = itemHolder.GetFirstOptionalMessage();

            if(itemGroup.ItemSummary.length === 0)
              itemGroup.ItemSummary = this.localeservice.instantTranslation("Pages.Combo.MandatoryOptional");
          }
          else
            itemGroup.ItemSummary = itemHolder.Summary;
        }
      }
    }
  }

  groupTap(itemGroup:ComboItemGroupModel)
  {
    if(itemGroup.CurrentItem.length > 0)
    {
      if(itemGroup.ItemPresetList.length > 1 || itemGroup.AllowEmpty)
      {
        var edit = this.localeservice.instantTranslation("Dialogs.Action.ComboGroup.Edit");
        var change = this.localeservice.instantTranslation("Dialogs.Action.ComboGroup.ChangeItem");

        var dialRef = this.alertDialog.open(ActionDialogComponent, 
        {
          height: 'fit-content',
          width: '60vw',
          data: 
          { 
            title:this.localeservice.instantTranslation("Dialogs.Action.ComboGroup.Title"),
            detail:this.localeservice.instantTranslation("Dialogs.Action.ComboGroup.Detail"), 
            itens: [edit, change], 
            cancel:this.localeservice.instantTranslation("Dialogs.Action.ComboGroup.Cancel") }
        });

        dialRef.afterClosed().subscribe(result =>
          {
            if(result === edit)
            {
              this.canGoToItem = true;

              var appname = String(this.route.snapshot.paramMap.get('appname'));

              this.router.navigateByUrl('/' + appname + '/comboitem/' + itemGroup.CurrentItem + '?status=edit');
            }
            
            if(result === change)
            {
              this.canGoToItem = true;

              var appname = String(this.route.snapshot.paramMap.get('appname'));
      
              this.router.navigateByUrl('/' + appname + '/pickcomboitem/' + itemGroup.ID + '?status=change');
            }

          });
      }
      else
      {
        this.canGoToItem = true;

        var appname = String(this.route.snapshot.paramMap.get('appname'));

        this.router.navigateByUrl('/' + appname + '/comboitem/' + itemGroup.CurrentItem + '?status=edit');
      }
    }
    else
    {
      this.canGoToItem = true;

      var appname = String(this.route.snapshot.paramMap.get('appname'));

      this.router.navigateByUrl('/' + appname + '/pickcomboitem/' + itemGroup.ID + '?status=new');
    }
  }

  updateCanSave()
  {
    var before = this.canSave;

    this.canSave = this.comboHolder.getValidation();

    if(before != this.canSave && this.canSave === true)
    {
      if(this.ripple)
      {
        const rippleRef = this.ripple.launch({ centered: true, persistent: true });
        
        setTimeout(() => rippleRef.fadeOut(), 1000);
      }
    }
  }

  save()
  {
    if(this.canSave === true)
    {
      if(this.isRedirect)
      {
        var dialRef = this.alertDialog.open(
          OrderTypePickerDialogComponent, 
          {
            height: 'fit-content',
            width: '90vw'
          });

          dialRef.afterClosed().subscribe((r) =>
          {
            if(r === 'done')
            {
              this.ngzone.run(() =>
              {
                this.currentorderservice.addCombo(this.comboHolder);

                this.pixelservice.facebookTrack('AddedToOrder', { name: this.comboHolder.Name, id: this.comboHolder.UniversalID } );

                this.canPop = true;

                var appname = String(this.route.snapshot.paramMap.get('appname'));

                this.router.navigateByUrl('/' + appname + '/menuitens?isredirect=true', { replaceUrl:true });
              });
            }
          })

          return;
      }

      if(this.status === 'new')
      {
        this.currentorderservice.addCombo(this.comboHolder);

        this.pixelservice.facebookTrack('AddedToOrder', { name: this.comboHolder.Name, id: this.comboHolder.UniversalID } );

        this.canPop = true;

        this.navigationservice.back();

        return;
      }

      if(this.status === 'edit')
      {
        var result = this.currentorderservice.saveCombo(this.comboHolder);

        if(result === true)
        {
          this.canPop = true;

          this.back();
        }
        else
        {
          this.alertDialog.open(AlertDialogComponent, 
            {
              height: 'fit-content',
              width: 'fit-content',
              data: { title:'Aviso', detail:'Não foi possível salvar o combo.', accept:'Entendi' }
            });
        }

        return;
      }
    }
  }

  copyLink()
  {
    this._snackBar.open("Link Copiado", undefined, { duration:2000 });
  }

  showWorkTime()
  {
    this.alertDialog.open(SummaryDialogComponent, 
      {
        height: 'fit-content',
        width: 'fit-content',
        data: 
        { 
          title: this.localeservice.instantTranslation("Dialogs.Summary.WorkTimeSummary.Title"), 
          detail:this.workweekservice.getWorkWeekSummary(), 
          accept:this.localeservice.instantTranslation("Dialogs.Summary.WorkTimeSummary.Accept") 
        }
      });
  }
}
